import { useTheme } from '@emotion/react';

import Icon from 'shopper/components/Icon';

const WishlistIcon = ({ ...props }) => {
  const theme = useTheme();

  return (
    <Icon name="heart-filled" color={theme.colors.icons.wishlist} {...props} />
  );
};

export default WishlistIcon;
